<template>
  <div>
<div v-if="isLoading" class="loading">Loading&#8230;</div>

<!-- CHECK LINK  -->
<div v-if="bool_invalid==true" class="columns is-gapless is-centered is-multiline mt-6">
<div class="column is-8 box has-text-centered has-text-weight-bold is-size-4">INVALID LINK !!</div>
</div>


<!-- ALL GOOD  -->
<div v-else class="columns is-centered is-gapless is-multiline mt-6">
<div class="column is-6">    
    <div class="columns is-multiline box has-background-light">

<div class="column is-12 has-text-centered has-text-weight-bold is-size-4 underIT">AIDE FINANCIÈRE</div>

<div class="column is-6">
<div class="columns is-gapless is-multiline">
    <div class="column is-6 isLabel">Nom</div>
    <div v-if="bool_miss_nom" class="column is-6 has-text-centered has-text-danger has-text-weight-bold">* Invalid</div>
    <div v-else class="column is-6"></div>
    <div class="column is-12" >
        <input @keypress="clear_messages()" v-model="var_stud_nom" class="input is-uppercase is-fullwidth has-text-weight-bold" type="text" placeholder="....">
    </div>
</div></div>

<div class="column is-6">
<div class="columns is-gapless is-multiline">
    <div class="column is-6 isLabel">Prenom</div>
    <div v-if="bool_miss_pre" class="column is-6 has-text-centered has-text-danger has-text-weight-bold">* Invalid</div>
    <div v-else class="column is-6"></div>
    <div class="column is-12" >
        <input @keypress="clear_messages()" v-model="var_stud_pre" class="input is-uppercase is-fullwidth has-text-weight-bold" type="text" placeholder="....">
    </div>
</div></div>

<div class="column is-6">
<div class="columns is-gapless is-multiline">
    <div class="column is-6 isLabel">Code permanent</div>
    <div v-if="bool_miss_code" class="column is-6 has-text-centered has-text-danger has-text-weight-bold">* Invalid</div>
    <div v-else class="column is-6"></div>
    <div class="column is-12" >
        <input @keypress="clear_messages()" v-model="var_stud_code" class="input is-uppercase is-fullwidth has-text-weight-bold" type="text" placeholder="....">
    </div>
</div></div>

<div class="column is-6">
<div class="columns is-gapless is-multiline">
    <div class="column is-6 isLabel">Date de naissance</div>
    <div v-if="bool_miss_bday" class="column is-6 has-text-centered has-text-danger has-text-weight-bold">* Invalid</div>
    <div v-else class="column is-6"></div>
    <div class="column is-12" >
        <flat-pickr
             @input="clear_messages()"
            class="input is-fullwidth has-text-weight-bold"
            :config="config"
            v-model="var_stud_bday"
            placeholder="...." 
            name="dtB">
        </flat-pickr>
    </div>
</div></div>


    <div class="column is-6 has-text-centered"> </div>

  <div class="column is-6 has-text-centered"> 
    <a @click="go_apply()" class="button is-fullwidth  has-background-grey-dark has-text-white">
      &nbsp;&nbsp;<span class="icon"><i class="fas fa-sign-out-alt"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;Demander</a> 
  </div>

    </div>
</div></div> <!-- END ALL GOOD  -->

<div v-if="return_code!=''" class="columns is-centered is-gapless is-multiline mt-6">
<div class="column is-6">    
 
    <div v-if="return_code=='00'" class="columns is-multiline box has-background-success-light">
        <!-- <div class="column is-3">{{return_code}} : </div> -->
        <div class="column is-12 colNotes has-text-centered is-size-5 has-text-weight-bold has-text-success-dark">{{return_message}}</div>
        <div class="column is-12 colNotes has-text-centered is-size-5 has-text-weight-bold"><a class="colNotes" :href="return_url">{{return_url}}</a></div>
    </div>
    <div v-else class="columns is-multiline box has-background-danger-light">
        <div class="column is-12 colNotes has-text-centered is-size-5 has-text-weight-bold has-text-danger-dark">{{return_message}}</div>
    </div>


</div></div>


  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment'; 
// import jsMES from "@/assets/js/js_mes.js";
import { French } from "flatpickr/dist/l10n/fr.js"

export default {
  name: 'compensation',
  props: {},

    data() {
        return {
            isLoading : false,
            bool_invalid : false,

bool_miss_nom:false,
bool_miss_pre:false,
bool_miss_code:false,
bool_miss_bday:false,

// var_stud_nom : 'Abex',
// var_stud_pre : 'M',
// var_stud_code : 'ABEM25036800',
// var_stud_bday : '1968-03-25',

var_stud_nom : '',
var_stud_pre : '',
var_stud_code : '',
var_stud_bday : '',

return_code:'',
return_message:'',
return_url:'',
 
array_ecoles : ['CAF','AEQ', 'MUSI'],


            config: { // FLATPICKER
                altFormat: "M j, y",
                altInput: true,
                disableMobile: "true",
                locale: French,
            },

    } }, // END DATA




    created() {
        this.var_ecole = this.$route.params.ecole

        // CHECK SCHOOL CODE
        if (this.array_ecoles.includes(this.var_ecole)) {this.bool_invalid=false}
        else {this.bool_invalid=true}


    // GET ECOLE DETAILS


    }, // END CREATED

    methods:{

clear_messages:function() {
    this.return_code=''
    this.return_message=''
    this.return_url=''
},


go_apply:function() {
            this.isLoading=true
            this.bool_miss_nom = false ; if (this.var_stud_nom.trim() == '') {this.bool_miss_nom = true}
            this.bool_miss_pre = false ; if (this.var_stud_pre.trim() == '') {this.bool_miss_pre = true}
            this.bool_miss_code = false ; if (this.var_stud_code.trim() == '') {this.bool_miss_code = true}
            this.bool_miss_bday = false ; if (this.var_stud_bday.trim() == '') {this.bool_miss_bday = true}

            if (this.bool_miss_nom==true || this.bool_miss_pre==true || this.bool_miss_code==true || this.bool_miss_bday==true) {this.isLoading=false ; return}

            setTimeout(() => { 


axios.get(this.$url+'/check_mes?ecole='+encodeURIComponent(this.var_ecole.toUpperCase())+'&codeperm='+encodeURIComponent(this.var_stud_code.toUpperCase())+'&nom='+encodeURIComponent(this.var_stud_nom.toUpperCase())+'&prenom='+encodeURIComponent(this.var_stud_pre.toUpperCase())+'&bday='+encodeURIComponent(this.var_stud_bday))
.then(res => {

// console.log(res.data)
// var dataReturn = res.data


var self = this;

    var parseString = require('xml2js').parseString;
    var stripNS = require('xml2js').processors.stripPrefix;
    const options = {
        tagNameProcessors: [stripNS],
        explicitArray: false
    };

    try {
        parseString(res.data, options, function (err, result) {
            self.return_code =  result.Envelope.Body.validerAdmissibiliteResponse.retour.informationExecution.code;
            self.return_message =  result.Envelope.Body.validerAdmissibiliteResponse.retour.informationExecution.message;
            self.return_url =  result.Envelope.Body.validerAdmissibiliteResponse.retour.urlFormulaire;
        })
    } catch {
            parseString(res.data, options, function (err, result) {
                self.return_code = result.Envelope.Body.Fault.Detail.ExceptionStandard.listeErreurStandard.erreurStandard.code;
                self.return_message = result.Envelope.Body.Fault.Detail.ExceptionStandard.listeErreurStandard.erreurStandard.message;
            })

    }

});

                this.isLoading=false
            }, 200);            

        }, //END GO APPLY


    }, // END METHODS




}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
